import { NgModule, ErrorHandler } from '@angular/core';
import { ShellDomainProvider } from '@ecap3/core';
import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';

const ORIGIN_URLS_TO_TRACK = ['https://deltamobile.seliseuat.com', 'https://my.deltagroup.cloud'];

function getEnvironment() : string {
    if (window.location.hostname.includes('deltamobile.seliselocal.com')) return  'Development';
    if (window.location.hostname.includes('deltamobile.selisestage.com')) return  'Staging';
    if (window.location.hostname.includes('deltamobile.seliseuat.com')) return  'UAT';
    if (window.location.hostname.includes('my.deltagroup.cloud')) return  'Production';
}

function addSentry(): void {
    Sentry.init({
        dsn: ShellDomainProvider['api'].SentryClientKeyDsn,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.routingInstrumentation,
                tracingOrigins: ORIGIN_URLS_TO_TRACK,
            }),
        ],
        tracesSampleRate: 1.0,

        environment: getEnvironment(),

        beforeSend(event, hint) {
            if (event.exception) {
                const error = event.exception.values[0].type || '';

                if (error === 'SyntaxError') {
                    return null; // Ignoring syntax error to send in sentry
                }
            }
            return event;
        },
    });
}
@NgModule({
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(), //Default
            //useClass: SentryErrorHandlerDelta, // If you want manual error control use this
        },
    ],
})
export class SentryModule {
    constructor() {
        if (!ShellDomainProvider['api'].sentryEnabled) return;
        addSentry();

        setTimeout(() => {
            throw new ReferenceError("Test Ref error for delta mobile stage");
        }, 3000)
    }
}

